
function PanFrontViewBF(vars) {
    const getAngle = (p5, v1, v2) => +(Math.abs(degrees(Math.atan(
        (v1.y - v2.y) / (v1.x - v2.x),
    ))).toFixed(1));

    const { p5, backgroundPattern } = this;

    const {
        panWidth, panHeight, splashWallWidth,
        drainWidth, drainX, plankFloorThickness,
        widthDeclineTotal, drainPlateWidth, drainHeight,
        drainInnerDiameter, drainExposed,
    } = vars;

    const { drainOpening } = panBaseSpec;

    const {
        cornerLineLength, panLineMargin,
    } = specConfig;

    const vLine = cornerLineLength / 4;
    const margin = 100;
    const padding = 10;
    const panFront = createGraphics(panWidth + margin, panHeight + margin);

    panFront.translate(padding, padding);
    panFront.fill(255);
    panFront.drawingContext.fillStyle = backgroundPattern;

    panFront.beginShape();
    panFront.vertex(0, 0);
    panFront.vertex(splashWallWidth, 0);

    // Splash Wall Meet Floor
    const leftWallMeetsFloor = createVector(
        splashWallWidth,
        panHeight - plankFloorThickness - widthDeclineTotal,
    );

    // Floor meet drain left
    const floorMeetsDrainLeft = createVector(
        drainX - (drainPlateWidth / 2),
        panHeight - plankFloorThickness,
    );

    const leftFloorAngle = getAngle(
        p5, leftWallMeetsFloor, floorMeetsDrainLeft,
    );

    // Floor meets drain right
    const floorMeetsDrainRight = createVector(
        drainX + (drainPlateWidth / 2),
        panHeight - plankFloorThickness,
    );

    // Floor meets right wall
    const floorMeetsRightWall = createVector(
        panWidth - splashWallWidth,
        panHeight - plankFloorThickness - widthDeclineTotal,
    );

    const rightFloorAngle = getAngle(
        p5, floorMeetsDrainRight, floorMeetsRightWall,
    );

    let leftWallAdjust = 0;
    let rightWallAdjust = 0;

    const angleDelta = Math.abs(leftFloorAngle - rightFloorAngle);
    let adjustmentPercentage = +((angleDelta / 10).toFixed(2));
    if (adjustmentPercentage > 1) adjustmentPercentage = 1;


    if (angleDelta > 2) {
        if (leftFloorAngle > rightFloorAngle) {
            leftWallAdjust = Math.ceil((floorMeetsDrainLeft.y - leftWallMeetsFloor.y) * adjustmentPercentage);
        } else {
            rightWallAdjust = Math.ceil((floorMeetsDrainRight.y - floorMeetsRightWall.y) * adjustmentPercentage);
        }
    }

    panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + leftWallAdjust);
    panFront.vertex(floorMeetsDrainLeft.x, floorMeetsDrainLeft.y);
    panFront.vertex(floorMeetsDrainRight.x, floorMeetsDrainRight.y);
    panFront.vertex(floorMeetsRightWall.x, floorMeetsRightWall.y + rightWallAdjust);

    panFront.vertex(panWidth - splashWallWidth, 0);
    panFront.vertex(panWidth, 0);
    panFront.vertex(panWidth, panHeight);
    panFront.vertex(0, panHeight);
    panFront.vertex(0, 0);
    panFront.endShape();

    textSize(14);

    // Pan Width
    this._createMeasureLine(
        splashWallWidth, -(panLineMargin + vLine - 5),
        panWidth - splashWallWidth, -(panLineMargin + vLine - 5),
        this.state.panWidthInches - (this.state.splashWallWidthInches * 2),
    );

    // Drain Width
    this._createMeasureLine(
        floorMeetsDrainLeft.x - 1, panHeight + vLine + 5,
        floorMeetsDrainRight.x + 1, panHeight + vLine + 5,
    );

    // Splash Wall Height
    this._createMeasureLine(
        panWidth + panLineMargin + vLine - 5, 0,
        panWidth + panLineMargin + vLine - 5, panHeight,
        panBaseSpec.height,
    );

    // Left Splash Wall Width
    this._createArrow(
        -5,
        -(panLineMargin + vLine - 5),
        'right',
        5,
    );

    // Right Splash Wall Width
    this._createArrow(
        panWidth + 5,
        -(panLineMargin + vLine - 5),
        'left',
        5,
    );

    // Splash wall amounts
    this._createText(
        this.state.splashWallWidthInches,
        -28, -(panLineMargin + vLine - 10),
    );

    this._createText(
        this.state.splashWallWidthInches,
        panWidth + 25, -(panLineMargin + vLine - 10),
    );

    image(panFront, -(padding), -(padding));

    const drainGraphic = this._createDrain({
        ...vars, vLine,
    });

    image(
        drainGraphic,
        (drainX - (drainWidth / 2) - 10),
        (panHeight - plankFloorThickness) - 10,
    );

    this._createText(
        drainOpening,
        drainX + drainWidth + 5,
        panHeight + vLine + 10,
    );

    stroke('black');
    strokeWeight(1);

    // Drain Width Pointer
    line(
        floorMeetsDrainRight.x - 1, panHeight + vLine + 5,
        floorMeetsDrainRight.x + 10, panHeight + vLine + 5,
    );

    // Splash Wall Width - LEFT
    line(0, -(panLineMargin), 0, -(panLineMargin + vLine));
    line(splashWallWidth, -(panLineMargin), splashWallWidth, -(panLineMargin + vLine));

    // Splash Wall Width - RIGHT
    line(panWidth, -(panLineMargin), panWidth, -(panLineMargin + vLine));
    line(panWidth - splashWallWidth, -(panLineMargin), panWidth - splashWallWidth, -(panLineMargin + vLine));

    // Pan Height
    line(
        panWidth + panLineMargin, 0,
        panWidth + panLineMargin + vLine, 0,
    );

    line(
        panWidth + panLineMargin, panHeight,
        panWidth + panLineMargin + vLine, panHeight,
    );

    //Back Splash Wall Line
    line(
        0, 0,
        panWidth, 0,
    );

    noStroke();
    textSize(20);

    text(
        'SECTION A-A',
        (panWidth / 2) - (this._getTextWidth('SECTION A-A') / 2),
        120,
    );
}